import { render, staticRenderFns } from "./RoutePath.vue?vue&type=template&id=6b2ed0b1&"
import script from "./RoutePath.vue?vue&type=script&lang=js&"
export * from "./RoutePath.vue?vue&type=script&lang=js&"
import style0 from "./RoutePath.vue?vue&type=style&index=0&id=6b2ed0b1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports